import { ValidationErrors } from "@angular/forms";

/** Returns a generic error message for common validation errors */
export function getErrorMessage(errors: ValidationErrors, errorKey: string): string {
		const error = errors?.[errorKey];
		switch (errorKey) {
			case 'required':
				return 'This field is required.';
			case 'minlength':
				return `Minimum length is ${error.requiredLength}.`;
			case 'maxlength':
				return `Maximum length is ${error.requiredLength}.`;
			case 'email':
				return 'Invalid email address.';
			case 'invalid_date':
				return 'Invalid date';
			default:
				return error.message || 'Invalid input.';
		}
	}